<template>
	<div class="px-3">
		<div class="box has-text-centered">
			<img src="@/assets/images/jobs/claim-success.gif"/>
			<br />
			<span class="bold-text">Yay! This job is complete</span>
			<br />
			<div>Our team will review your findings and may reach out with next steps.</div>
			<br />
			<div v-if="showAllJobs">
				<div>In the meantime, check out other  available jobs below.</div>
				<br />
				<button class="button is-primary" @click="close({seeAll: true})">See all jobs</button>
			</div>
		</div>
	</div>
	
</template>

<script lang="ts">
import config from '@/config';
import { closeModal } from '@/utils/mixins';
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [closeModal],
	computed: {
		showAllJobs () {
			return !config.noLoginApp
		}
	}
})
</script>

<style scoped>
	img{
		max-width: 150px;
	}
</style>
